import _defineProperty from 'babel-runtime/helpers/defineProperty';
import { StateType as SessionStateType } from '@central-products/interface-session-manager';
import { publish, subscribe } from '../patched-message-bus';
import { SESSION_STATE_CHANGED } from '../topics';
import { commandButtonHide } from './message-bus-helpers/commandButtonHide';
import { commandButtonShow } from './message-bus-helpers/commandButtonShow';

export default (function () {
  var _SESSION_STATES;

  var SESSION_STATES = (_SESSION_STATES = {}, _defineProperty(_SESSION_STATES, SessionStateType.UNKNOWN, commandButtonHide), _defineProperty(_SESSION_STATES, SessionStateType.NOT_LOGGED_IN, commandButtonHide), _defineProperty(_SESSION_STATES, SessionStateType.LOGGED_IN, commandButtonShow), _SESSION_STATES);

  subscribe({
    topic: SESSION_STATE_CHANGED,
    callback: function callback(_, _ref) {
      var state = _ref.state;
      return publish(SESSION_STATES[state]());
    }
  });
});
//# sourceMappingURL=workflow.js.map